import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
  name: 'dob'
})
export class DobPipe implements PipeTransform {

  transform(value: any): any {
    if (!value)
      return value;
    else {
      if (value.length == 8) {
        let yr = value.substring(0, 4);
        let mnth = value.substring(4, 6);
        let day = value.substring(6);
        let parsed = `${mnth}/${day}/XXXX`;
        return parsed;
      }
      return moment(value).format('MM') + '/' + moment(value).format('DD') + '/XXXX';
    }
  }

}
